import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isoWeek from 'dayjs/plugin/isoWeek';
import localeData from 'dayjs/plugin/localeData';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import 'dayjs/locale/en-au';

/**
 * Registers every dayjs plugin and the locale the app depends on.
 *
 * Both live on a shared singleton the whole bundle sees, so this belongs to the
 * entry points rather than to any module that happens to need it: a route loaded
 * on its own carries only its own chunk, and a plugin registered from some other
 * chunk is a method that exists or not depending on how the user arrived. The
 * locale is what makes weeks start on Monday, so it decides every `startOf('week')`.
 */
export function configureDayjs() {
  dayjs.extend(customParseFormat);
  dayjs.extend(isBetween);
  dayjs.extend(isSameOrAfter);
  dayjs.extend(isSameOrBefore);
  dayjs.extend(isoWeek);
  dayjs.extend(localeData);
  dayjs.extend(relativeTime);
  dayjs.extend(timezone);
  // timezone is built on utc; localeData and weekOfYear back the MUI date pickers
  dayjs.extend(utc);
  dayjs.extend(weekOfYear);
  dayjs.locale('en-au');
}
